import { getJSON } from "@js/helpers/communication.js";
import * as Routes from "@js/generated/routes.js";

// SS_UPDATE_ACTIVE_QUERY

export const SS_UPDATE_ACTIVE_QUERY = "SS_UPDATE_ACTIVE_QUERY";

export const ssUpdateActiveQuery = (activeQuery) => ({
  type: SS_UPDATE_ACTIVE_QUERY,
  activeQuery: activeQuery,
});

// SS_UPDATE_MAILING_LIST_ID

export const SS_UPDATE_MAILING_LIST_ID = "SS_UPDATE_MAILING_LIST_ID";

export const ssUpdateMailingListID = (id) => ({
  type: SS_UPDATE_MAILING_LIST_ID,
  id: id,
});

// SS_UPDATE_ALL_ORGANIZATIONS

export const SS_UPDATE_ALL_ORGANIZATIONS = "SS_UPDATE_ALL_ORGANIZATIONS";

export const ssUpdateAllOrganizations = (value) => ({
  type: SS_UPDATE_ALL_ORGANIZATIONS,
  value: !!value,
});

// SUBMITTING QUERIES

export const ssSubmitQuery = (updateHistory) => (dispatch, getState) => {
  dispatch(ssSubmitQueryStart());

  let state = getState();
  let query = state.activeQuery.trim();

  if (updateHistory) {
    let historyParams = { q: query };
    if (state.mailingListID)
      historyParams.mailing_list_id = state.mailingListID;
    if (state.allOrganizations)
      historyParams.all_organizations = state.allOrganizations;
    let historyRoute = Routes.subscribers_search_by_email_index_path(
      historyParams,
    );
    history.pushState({}, "", historyRoute);
  }

  // The route helpers percent-encode path segments themselves. Encoding `query`
  // here as well would escape the `%` of that encoding, so the server would
  // decode the segment back to `user%40example.com` rather than the address.

  let route = state.mailingListID
    ? Routes.api_v2_mailing_list_subscriber_search_by_email_path({
        mailing_list_id: state.mailingListID,
        email: query,
      })
    : state.allOrganizations
    ? Routes.api_v2_organization_subscriber_search_by_email_path({
        organization_id: "all",
        email: query,
      })
    : Routes.api_v2_organization_subscriber_search_by_email_path({
        organization_id: state.organizationID,
        email: query,
      });

  let suppressionRoute = state.mailingListID
    ? Routes.api_v2_mailing_list_suppressed_address_search_by_email_path({
        mailing_list_id: state.mailingListID,
        email: query,
      })
    : state.allOrganizations
    ? Routes.api_v2_organization_suppressed_address_search_by_email_path({
        organization_id: "all",
        email: query,
      })
    : Routes.api_v2_organization_suppressed_address_search_by_email_path({
        organization_id: state.organizationID,
        email: query,
      });

  getJSON(route, (subscriberData, err) => {
    if (err) {
      dispatch(ssSubmitQueryFailure(err));
    } else {
      getJSON(suppressionRoute, (suppressionData, suppressionError) => {
        if (suppressionError) {
          dispatch(ssSubmitQueryFailure(suppressionError));
        } else {
          dispatch(
            ssSubmitQuerySuccess({
              subscribers: subscriberData.data,
              suppression: suppressionData.data,
              query: query,
            }),
          );
        }
      });
    }
  });
};

// SS_SUBMIT_QUERY_START

export const SS_SUBMIT_QUERY_START = "SS_SUBMIT_QUERY_START";

export const ssSubmitQueryStart = () => ({
  type: SS_SUBMIT_QUERY_START,
});

// SS_SUBMIT_QUERY_FAILURE

export const SS_SUBMIT_QUERY_FAILURE = "SS_SUBMIT_QUERY_FAILURE";

export const ssSubmitQueryFailure = (err) => ({
  type: SS_SUBMIT_QUERY_FAILURE,
  error: err,
});

// SS_SUBMIT_QUERY_SUCCESS

export const SS_SUBMIT_QUERY_SUCCESS = "SS_SUBMIT_QUERY_SUCCESS";

export const ssSubmitQuerySuccess = (data) => ({
  type: SS_SUBMIT_QUERY_SUCCESS,
  subscribers: data.subscribers,
  suppression: data.suppression,
  query: data.query,
});
